import type { FC } from 'react';
import { FaAngleLeft, FaAngleRight, FaTimes } from 'react-icons/fa';
import * as Styled from './styled';
import type { ImageLightboxProps } from './types';

export const ImageLightbox: FC<ImageLightboxProps> = (props) => {
  const { images, index, onPrevious, onNext, onClose, onThumbnailClick, ...rest } = props;

  return (
    <Styled.Wrapper {...rest}>
      <Styled.Overlay onClick={onClose} />
      <Styled.MainImage src={images[index] ?? ''} onContextMenu={(e) => e.preventDefault()} />
      <FaTimes css={Styled.iconCloseStyle} onClick={onClose} />
      {images.length > 1 && (
        <>
          <FaAngleLeft css={Styled.iconLeftStyle} onClick={onPrevious} />
          <FaAngleRight css={Styled.iconRightStyle} onClick={onNext} />
          <Styled.ThumbnailContainer>
            {images.map((image, idx) => (
              <Styled.Thumbnail
                key={idx}
                src={image}
                active={idx === index}
                onClick={() => onThumbnailClick?.(idx)}
                onContextMenu={(e) => e.preventDefault()}
              />
            ))}
          </Styled.ThumbnailContainer>
        </>
      )}
    </Styled.Wrapper>
  );
};
